import React, { FC } from 'react';
import { EntityChip, Icons, Tooltip } from '@silverfort/sf-components';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

import { Entity } from '../../../../api';

interface Props {
    mainEntities?: Entity[];
}

const EntitiesColumn: FC<Props> = ({ mainEntities = [] }) => {
    const nonNullEntities = mainEntities.filter((entity) => !!entity);

    const getEntityIdentifier = (mainEntity: Entity) => {
        return mainEntity.name || mainEntity.identifier;
    };

    return (
        <div className="h-full w-full flex items-center gap-2">
            {nonNullEntities.length > 0 ? (
                <>
                    {nonNullEntities.length === 1 ? (
                        <EntityChip
                            text={getEntityIdentifier(nonNullEntities[0])}
                            icon={nonNullEntities[0].type === AD_ENTITY_TYPES.USER ? Icons.User : Icons.Server}
                            defaultCursor
                        />
                    ) : (
                        <Tooltip
                            className="w-full h-full flex items-center"
                            title=""
                            description={nonNullEntities.map((entity) => getEntityIdentifier(entity)).join(', ')}>
                            <EntityChip text="Multiple Entities" icon={Icons.UserGroup} defaultCursor />
                        </Tooltip>
                    )}
                </>
            ) : (
                <div className="text-12 font-sf text-sf-gray-500">None</div>
            )}
        </div>
    );
};

export default EntitiesColumn;
